module.exports = __webpack_public_path__ + "media/home/plan-feature-free-1d91fb66.jpg";